import PropTypes from 'prop-types';
import React from 'react';

import styles from './DayHeading.module.scss';
import SmallCaps from './SmallCaps';

const dayWords = (day) => {
  const ago = /^(\d+)d ago$/.exec(day);
  if (ago) return `${ago[1]} ${ago[1] === '1' ? 'day' : 'days'} ago`;
  const ahead = /^in (\d+)d$/.exec(day);
  if (ahead) return `In ${ahead[1]} ${ahead[1] === '1' ? 'day' : 'days'}`;
  return day;
};

const DayHeading = ({ heading }) => {
  const [day, ...rest] = heading.split(' \u00b7 ');
  return (
    <h4 className={styles.heading}>
      <SmallCaps size="sm" tone="strong">
        {dayWords(day)}
      </SmallCaps>
      {rest.length > 0 && (
        <span className={styles.quiet}>
          {'\u00b7 '}
          {rest.join(' \u00b7 ')}
        </span>
      )}
      <span className={styles.rule} aria-hidden="true" />
    </h4>
  );
};

DayHeading.propTypes = { heading: PropTypes.string.isRequired };

export default DayHeading;
